import { keyframes, styled } from "src/styles/theme";
import * as RadixDialog from "@radix-ui/react-dialog";

const overlayShow = keyframes({
  "0%": { opacity: 0 },
  "100%": { opacity: 1 },
});

const contentShow = keyframes({
  "0%": { opacity: 0, transform: "translate(-50%, -8px) scale(1)" },
  "100%": { opacity: 1, transform: "translate(-50%, 0) scale(1)" },
});

const Overlay = styled(RadixDialog.Overlay, {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 10,
  background: "$backdrop",
  animation: `${overlayShow} $transitions$duration1 cubic-bezier(0.16, 1, 0.3, 1)`,
});

const Content = styled(RadixDialog.Content, {
  width: "90vw",
  maxWidth: "500px",
  maxHeight: "75vh",
  position: "fixed",
  top: "$12",
  left: "50%",
  transform: "translate(-50%, 0)",
  display: "flex",
  flexDirection: "column",
  borderRadius: "$2",
  boxShadow: "$5",
  backgroundColor: "$background",
  zIndex: 11,
  animation: `${contentShow} $transitions$duration1 cubic-bezier(0.16, 1, 0.3, 1)`,
});

const ContentHeader = styled("header", {
  position: "relative",
  padding: "$6 $6 $3",
});

const Title = styled(RadixDialog.Title, {
  margin: 0,
  color: "$neutralTextContrast",
  fontSize: "$xl",
  fontWeight: "$semibold",
});

const Description = styled(RadixDialog.Description, {
  margin: "$2 0 0",
  color: "$neutralText",
  fontSize: "$sm",
  lineHeight: 1.5,
});

const Close = styled(RadixDialog.Close, {
  applyReset: "btn",
  position: "absolute",
  top: "$6",
  right: "$6",
  margin: "-$2",
  padding: "$2",
});

const ContentBody = styled("div", {
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

export const Dialog = {
  Root: RadixDialog.Root,
  Portal: RadixDialog.Portal,
  Trigger: RadixDialog.Trigger,
  Overlay,
  Content,
  ContentHeader,
  Title,
  Close,
  Description,
  ContentBody,
};
